export default "__VITE_PUBLIC_ASSET__9236882c__"